import { DoqFaceSvgProps } from '../types';

const ComponentMergeEmpty = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    role="presentation"
  >
    <defs>
      <clipPath id="clip0_1698_46578">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_1698_46578)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-component-merge-empty">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#76D1A5"
        mask="url(#bottom-mask-component-merge-empty)"
      />

      <mask
        id="mask0_1698_46578"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_1698_46578)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184ZM171 174C169.895 174 169 174.895 169 176C169 177.105 169.895 178 171 178H185C186.105 178 187 177.105 187 176C187 174.895 186.105 174 185 174H171Z"
        fill="#2974C4"
      />
      <path
        d="M142 183.5C146.418 183.5 150 179.918 150 175.5C150 171.082 146.418 167.5 142 167.5C137.582 167.5 134 171.082 134 175.5C134 179.918 137.582 183.5 142 183.5Z"
        fill="#2974C4"
      />
      <path
        d="M178 183.5C182.418 183.5 186 179.918 186 175.5C186 171.082 182.418 167.5 178 167.5C173.582 167.5 170 171.082 170 175.5C170 179.918 173.582 183.5 178 183.5Z"
        fill="#2974C4"
      />
      <path
        d="M141.5 189C148.68 189 154.5 183.18 154.5 176C154.5 168.82 148.68 163 141.5 163C134.32 163 128.5 168.82 128.5 176C128.5 183.18 134.32 189 141.5 189Z"
        fill="#141414"
      />
      <path
        d="M178.5 189C185.68 189 191.5 183.18 191.5 176C191.5 168.82 185.68 163 178.5 163C171.32 163 165.5 168.82 165.5 176C165.5 183.18 171.32 189 178.5 189Z"
        fill="#141414"
      />
      <path d="M126 177.5V172.5H142V177.5H126Z" fill="#141414" />
      <path d="M152 172.5V177.5H168V172.5H152Z" fill="#141414" />
      <path d="M178 172.5V177.5H194V172.5H178Z" fill="#141414" />
      <g opacity="0.5">
        <path
          d="M96 243C96 242.448 96.4477 242 97 242H223C223.552 242 224 242.448 224 243V245C224 245.552 223.552 246 223 246H97C96.4477 246 96 245.552 96 245V243Z"
          fill="#2974C4"
        />
        <path
          d="M96 277C96 276.448 96.4477 276 97 276H223C223.552 276 224 276.448 224 277V279C224 279.552 223.552 280 223 280H97C96.4477 280 96 279.552 96 279V277Z"
          fill="#2974C4"
        />
        <path
          d="M97 258C96.4477 258 96 258.448 96 259V261C96 261.552 96.4477 262 97 262H223C223.552 262 224 261.552 224 261V259C224 258.448 223.552 258 223 258H97Z"
          fill="#2974C4"
        />
        <path
          d="M96 293C96 292.448 96.4477 292 97 292H223C223.552 292 224 292.448 224 293V295C224 295.552 223.552 296 223 296H97C96.4477 296 96 295.552 96 295V293Z"
          fill="#2974C4"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160 208C154.078 208 148.907 204.783 146.141 200L151.056 200C153.253 202.455 156.446 204 160 204C163.554 204 166.747 202.455 168.944 200L173.859 200C171.093 204.783 165.922 208 160 208Z"
        fill="#2974C4"
      />
    </g>
  </svg>
);

export { ComponentMergeEmpty };
